import { render, staticRenderFns } from "./ChunkUpload.vue?vue&type=template&id=3058ec98"
import script from "./ChunkUpload.vue?vue&type=script&lang=js"
export * from "./ChunkUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports